import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  constructor() {
    super();
    this.tags = this.querySelectorAll('.tag');
    this.items = this.querySelectorAll('.item');

    this.tags.forEach(tag => {
      tag.addEventListener('click', this.clickHandler.bind(this));
    });
  }

  clickHandler(event) {
    this.tags.forEach(t => t.classList.remove('active'));
    const dataTag = event.target.dataset.tag;
    
    document.querySelectorAll(`[data-tag*="${dataTag}"]`).forEach(item => {
      item.classList.add('active');
    });

    if (event.target.dataset.tag) {
      event.preventDefault();
      const tagName = event.target.dataset.tag;
      this.filterItemsByTag(tagName);
    } else {
      this.clearFilter();
    }
  }

  filterItemsByTag(tagName) {
    this.items.forEach(item => {
      const itemTags = item.dataset.tags.split(',');
      if (itemTags.includes(tagName)) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  clearFilter() {
    this.items.forEach(item => {
      item.style.display = '';
    });
  }
  
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
